module.exports = __webpack_public_path__ + "static/img/3538_phase_function_Paper_Points.f36dbf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3538_phase_function_Paper_Points.png
// module id = PBgd
// module chunks = 0